export enum EntityFilter {
  CLIENT = 'Client',
  SIMSPECIALIST = 'SimSpecialist',
  PROJECT = 'Project',
}
